<section class="service-intro content-wrapper">
  <div class="service-content">
    <h1 class="title">
      Expert Digital Marketing & SEO Services in Goa and Beyond
    </h1>
    <p class="description">
      Geekeno offers strategic, results-driven digital marketing services in Goa
      — helping businesses across India and globally grow online. From SEO and
      PPC to content marketing, email campaigns, and social media management, we
      deliver tailored solutions that boost visibility, engagement, and ROI.
    </p>
  </div>
  <div class="decorative-elements is-hidden-touch">
    <img
      src="/assets/services/deco-element.png"
      loading="eager"
      fetchpriority="high"
      width="265"
      height="400"
      alt=""
      role="presentation"
    />
  </div>
</section>

<section class="services">
  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/digital-marketing/social-media.avif"
        loading="eager"
        fetchpriority="high"
        width="445"
        height="431"
        alt="Social media management and strategy for growing brands"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Social Media Management</h2>
      <p class="service-description">
        We craft platform-specific strategies for Instagram, Facebook, and
        LinkedIn — including post design, ad targeting, and community engagement
        — to grow your brand's social presence and drive conversions.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
  <div class="service-row content-wrapper reverse">
    <div class="service-image">
      <img
        src="/assets/services/digital-marketing/seo.webp"
        loading="lazy"
        width="445"
        height="431"
        alt="Technical SEO audit dashboard"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Search Engine Optimization</h2>
      <p class="service-description">
        Our SEO services include technical audits, keyword research, on-page
        optimization, and backlink building — helping your website rank higher
        and attract qualified traffic.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/digital-marketing/pay-per-click.webp"
        loading="lazy"
        width="445"
        height="431"
        alt="Google Ads campaign performance report"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Pay Per Click Advertising</h2>
      <p class="service-description">
        We manage Google Ads, Meta Ads, and eCommerce PPC campaigns with
        precision targeting, compelling creatives, and A/B testing — ensuring
        every click delivers measurable ROI.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper reverse">
    <div class="service-image">
      <img
        src="/assets/services/digital-marketing/content-marketing.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="Content Marketing"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Content Marketing</h2>
      <p class="service-description">
        Our content marketing team creates SEO-optimized blogs, articles, and
        social media content that build authority, drive traffic, and connect
        with your audience.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/digital-marketing/email-marketing.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="Email Marketing"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Email Marketing</h2>
      <p class="service-description">
        From automated drip campaigns to beautifully designed newsletters, we
        help you nurture leads and increase conversions through strategic email
        marketing.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper reverse">
    <div class="service-image">
      <img
        src="/assets/services/digital-marketing/ecommerce-marketing.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="ECommerce Marketing"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Ecommerce Marketing</h2>
      <p class="service-description">
        We optimize your online store with Shopify SEO, WooCommerce marketing,
        and Amazon product ads — boosting visibility, conversions, and customer
        retention.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
</section>
